import React from 'react';
import PropTypes from 'prop-types';
import ReactExport from 'react-data-export';
import { titleize, fullAddress, deriveStatusName, replaceFalsyObjVals } from '../../../../../../utils';
import { getDuration, getDaysStringFromDuration } from '../../../../../../utils/dateUtils';
import { displayVendorLabel } from 'config/constants';

const DEFAULT = 'N/A';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class PhaseExcelSheet extends React.Component {
  componentDidMount = () => {
    this.Interval = setInterval(this.props.unmountExcelSheet.bind(this), 2500);
  }

  componentWillUnMount = () => clearInterval(this.Interval);

  buildExcelSheet = (data, name) => {
    const verifiedData = data && data.length ? data : [{ results: 'No Data Available' }];
    const allKeys = Array.from(new Set(data.flatMap(obj => Object.keys(obj))));
    return (<ExcelFile hideElement>
      <ExcelSheet data={verifiedData} name={name}>
        {allKeys.map(key => (<ExcelColumn key={key} label={titleize(key)} value={key} />))}
      </ExcelSheet>
    </ExcelFile>);
  }

  render = () => {
    const simplifiedPhases = this.props.phases.map((phase) => {
      const { customer_name: customerName = '', created_at: createdOn = '', source = '',
              phone_numbers = [], email = '', project_number: projectNumber = '', type: phaseType = '',
              surface_name: surfaceType = '', product_type: productType = '', sqft,
              due_at: dueDate = '', status_name = '', last_assignee: assignedTo = '',
              last_appt_start: appointmentStartDate = '', flags: phaseFlags = [],
              last_event_time: lastEventTime = '', last_event_details: lastEventDetails = '',
              recent_note: latestNote = '', contractor_notes = '', store_number: storeNumber = '',
              workroom_name: workroom = '' } = phase || {};
      const phoneNumber = ((phone_numbers || [])[0] && phone_numbers[0].number) || '';
      const address = fullAddress(phase);
      const mot = getDaysStringFromDuration(getDuration(phase));
      const status = deriveStatusName(status_name, { source, workroom });
      const contractorNotes = contractor_notes ? contractor_notes.replace(/\n\s*\n/g, ' | ') : contractor_notes;
      const flags = (phaseFlags || []).length ? phaseFlags.filter(f => f.name || false).map(f => f.name).join(', ') : '';
      return replaceFalsyObjVals({
        customerName,
        createdOn,
        source: displayVendorLabel(source),
        phoneNumber,
        address,
        email,
        projectNumber,
        phaseType,
        surfaceType,
        productType,
        sqft,
        dueDate,
        mot,
        status,
        assignedTo,
        appointmentStartDate,
        flags,
        lastEventDetails,
        lastEventTime,
        latestNote,
        contractorNotes,
        workroom,
        storeNumber,
      }, DEFAULT);
    }) || [];
    return this.buildExcelSheet(simplifiedPhases, 'Phase List');
  }
}

PhaseExcelSheet.propTypes = { phases: PropTypes.array, unmountExcelSheet: PropTypes.func };

export default PhaseExcelSheet;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseList/components/PhaseExcelSheet.jsx